"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apsResultFactory = exports.apsTrainingFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.apsTrainingFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    personaId: mocks_1.persona.id,
    certificateUrl: 'http://example.com',
    dateCreated: mocks_1.dates.date2000,
    surveyCode: 'standard',
    dateCompleted: mocks_1.dates.date2000,
    score: 100,
    passed: true,
});
exports.apsResultFactory = Factory.Sync.makeFactory({
    success: true,
    trainings: [
        exports.apsTrainingFactory.build()
    ]
});
